import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-paginator-control',
  template: `
    <p-paginator
      *ngIf="(totalRecords > rows) || alwaysShow"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="rowsPerPageOptions"
      (onPageChange)="onPageChange($event)"
    ></p-paginator>
  `,
  styles: [],
  imports: [PaginatorModule, CommonModule],
})
export class PaginatorControlComponent {
  @Input() first: number = 0;
  @Input() rows: number = 10;
  @Input() totalRecords: number = 0;
  @Input() rowsPerPageOptions: number[] = [5, 10, 20, 30];
  @Input() alwaysShow: boolean = false;
  // [showCurrentPageReport]="true"
  // [showPageLinks]="false"
  // [showJumpToPageDropdown]="false"
  // currentPageReportTemplate="Mostrando {first} de {last} dos {totalRecords}"
  @Output() pageChange = new EventEmitter<any>();

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }
}
